<div class="input-container w-full flex flex-col">
  @if(!currentStudy){
  <div class="warning-banner">
    <div class="warning-icon">
      <ng-icon name="phosphorSealWarning" size="18" />
    </div>
    <span>To get started, please connect to a repository.</span>
  </div>
  }

  <div class="input-wrapper">
    <!-- Main textarea area -->
    <div class="textarea-container">
      <textarea #messageTextarea class="main-textarea" [(ngModel)]="userInput"
        (keyup.enter)="userInput && userInput.trim() ? handleSend() : null" [placeholder]="displayPlaceholder"
        (input)="autoResize($event)" [rows]="workspace ? 3 : 2"
        [disabled]="isTypingPrompt || aiService.getAiIsWritingValue()">
      </textarea>
    </div>

    <!-- Bottom toolbar -->
    <div class="toolbar">
      <!-- Left side - Study selector -->
      <div class="toolbar-left">
        <button class="study-button" (click)="createRepoVisible = true" [class.has-study]="currentStudy">
          <div class="study-button-icon">
            <ng-icon [name]="currentStudy ? 'heroCheckCircleSolid' : 'heroPlus'" size="16px"></ng-icon>
          </div>
          <span class="study-button-text">{{ currentStudy || 'Select Repository' }}</span>
          <ng-icon name="heroChevronDown" size="14px" class="study-chevron"></ng-icon>
        </button>
      </div>

      <!-- Right side - Actions -->
      <div class="toolbar-right">
        <!-- Typing indicator -->
        <div *ngIf="isTypingPrompt" class="typing-indicator">
          <span class="typing-dot"></span>
          <span class="typing-dot"></span>
          <span class="typing-dot"></span>
        </div>

        <!-- Workflow selector -->
        <!-- <div *ngIf="currentStudy" class="workflow-selector">
          @if(selectedWorkflow) {
            <div class="workflow-badge">
              <span class="workflow-label" (click)="sdtmDlg.toggle(selectedWorkflow.type)">
                {{ selectedWorkflow.label }}
              </span>
              <button class="workflow-clear" (click)="$event.stopImmediatePropagation(); updateWorkflow(null);">
                <ng-icon name="heroXMark" size="14px"></ng-icon>
              </button>
            </div>
          } @else {
            <button class="workflow-button" #workflowText (click)="op.toggle($event, workflowText)">
              <ng-icon name="phosphorGraph" size="18px"></ng-icon>
              @if(!workspace) {
                <span>Workflows</span>
              }
            </button>
          }

          <p-popover #op styleClass="workflow-popover">
            <div class="workflow-menu">
              @for(item of workflowOptions | keyvalue; track item.value){
                <button class="workflow-menu-item"
                  (click)="updateWorkflow(item.value); op.hide(); sdtmDlg.toggle(item.value.type)">
                  <ng-icon name="phosphorGraph" size="16px"></ng-icon>
                  <span>{{ item.value.label }}</span>
                </button>
              }
            </div>
          </p-popover>
        </div> -->

        <!-- Send button -->
        @if(!aiService.getAiIsWritingValue()){
        <button class="send-button" [class.workspace-mode]="workspace"
          [class.disabled]="!userInput || userInput.length === 0" (click)="handleSend()"
          [disabled]="!userInput || userInput.length === 0">
          <ng-icon name="heroArrowUpSolid" size="16"></ng-icon>
        </button>
        }@else {
        <button class="stop-button" (click)="handleStop()">
          <ng-icon name="heroStopSolid" size="14"></ng-icon>
        </button>
        }
      </div>
    </div>
  </div>

  <app-select-stdm #sdtmDlg (submitWorkflow)="onWorkflowSubmit($event)"></app-select-stdm>
  <app-create-repo [(createRepoVisible)]="createRepoVisible"></app-create-repo>
</div>